// Snapchat Pixel helper — wraps the global `snaptr` function (loaded in index.html)
// with safe, typed calls used across the funnel:
//   PAGE_VIEW  → fires automatically on page load (in index.html)
//   START_CHECKOUT → user clicks any buy CTA
//   ADD_BILLING (Initiate Payment) → checkout page loads / Stripe Elements ready
//   PURCHASE   → success page sees Paid status

const CONTENTS = {
  pdf: { id: "bluebook_pdf", name: "الكتاب الأزرق - PDF", price: 27, category: "ebook" },
  pdf_audio: { id: "bluebook_pdf_audio", name: "الكتاب الأزرق - PDF + الصوتية", price: 41, category: "ebook" },
  pink_audio: { id: "bluebook_pink_audio", name: "الكتاب الوردي - البرنامج الصوتي", price: 39.73, category: "audio" },
  ai_work_upgrade: { id: "ai_work_upgrade", name: "AI Work Upgrade", price: 26.24, category: "course" },
};

function safeCall(eventName, params) {
  if (typeof window === "undefined" || typeof window.snaptr !== "function") return;
  // Egypt funnel: never fire Snap events even if the loader somehow ran.
  try {
    if (window.sessionStorage && sessionStorage.getItem("bb_funnel") === "eg") return;
  } catch (_) { /* ignore */ }
  try {
    window.snaptr("track", eventName, params);
  } catch (_) {
    /* swallow */
  }
}

function isEgPkg(pkg) {
  return typeof pkg === "string" && (pkg.endsWith("_eg") || pkg.endsWith("_eg_exit"));
}

// Identify the current visitor — call once we know their email.
// Snap will hash the value internally; we pass plain.
export function snapIdentify({ email, phone, pkg } = {}) {
  if (typeof window === "undefined" || typeof window.snaptr !== "function") return;
  if (isEgPkg(pkg)) return;
  try {
    if (window.sessionStorage && sessionStorage.getItem("bb_funnel") === "eg") return;
  } catch (_) { /* ignore */ }
  const params = {};
  if (email) params.user_email = email.trim().toLowerCase();
  if (phone) params.user_phone_number = phone.trim();
  if (!Object.keys(params).length) return;
  try {
    window.snaptr("init", "818b28e7-aee1-432a-95eb-f281d3bd2f28", params);
  } catch (_) { /* swallow */ }
}

function build(pkg) {
  const c = CONTENTS[pkg] || CONTENTS.pdf;
  return {
    price: c.price,
    currency: "USD",
    item_ids: [c.id],
    item_category: c.category,
    number_items: 1,
  };
}

// CTA click → "Checkout" intent
export function snapStartCheckout(pkg = "pdf") {
  if (isEgPkg(pkg)) return;
  safeCall("START_CHECKOUT", build(pkg));
}

// Checkout page reached / payment form interacted → "Initiate Payment"
export function snapInitiatePayment(pkg = "pdf", email) {
  if (isEgPkg(pkg)) return;
  const p = build(pkg);
  if (email) p.user_email = email.trim().toLowerCase();
  safeCall("ADD_BILLING", p);
}

// Successful purchase
export function snapPurchase(pkg = "pdf", orderId, email) {
  // Egypt orders (Geidea or Egypt-via-Stripe) are tracked via TikTok only — skip Snap.
  if (isEgPkg(pkg)) return;
  const p = build(pkg);
  if (orderId) p.uuid_c1 = orderId;
  if (email) p.user_email = email.trim().toLowerCase();
  safeCall("PURCHASE", p);
}
